<div class="flex items-center">
  <span
    class="status h-2 w-2 rounded-full"
    [ngClass]="{
        'bg-unavailable': inactive,
        'bg-primary': !inactive && canonicalStatus === deviseStatusEnum.Available,
        'bg-red': !inactive && (canonicalStatus === deviseStatusEnum.AfterUseAwaitingInspection || canonicalStatus === deviseStatusEnum.SentForRepair || canonicalStatus === deviseStatusEnum.FaultyDevice),
        'bg-teal': !inactive && canonicalStatus === deviseStatusEnum.Assigned,
        'bg-yellow': !inactive && canonicalStatus === deviseStatusEnum.InUse,
        'bg-blue': !inactive && canonicalStatus === deviseStatusEnum.Charging
      }"
  ></span>
  <div *ngIf="!isWithoutText" class="ml-[5px]">
    {{ label || "Status not Available" }}
    <span *ngIf="!inactive && online != undefined && canonicalStatus === deviseStatusEnum.InUse" class="mx-1"> {{online ? '(Online)' : '(Offline)'}}</span>
  </div>
</div>
